import { useMutation, useQueryClient } from "react-query";

import { markNotificationsAsVisited } from "../../api/notifications";

import { NOTIFICATIONS_QUERY_KEY } from "../queries/useNotificationsQuery";

export const useMarkNotificationsAsVisitedMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(markNotificationsAsVisited, {
    onMutate: async ids => {
      await queryClient.cancelQueries(NOTIFICATIONS_QUERY_KEY);

      const oldNotifications = queryClient.getQueryData(
        NOTIFICATIONS_QUERY_KEY
      );

      // optimistic update
      queryClient.setQueryData(NOTIFICATIONS_QUERY_KEY, old =>
        old.map(notification => {
          if (ids.includes(notification.id)) {
            return {
              ...notification,
              visited: true
            };
          }

          return notification;
        })
      );

      return { oldNotifications };
    },

    onError: (err, ids, context) => {
      queryClient.setQueryData(
        NOTIFICATIONS_QUERY_KEY,
        context.oldNotifications
      );
    },

    onSettled: () => {
      queryClient.invalidateQueries(NOTIFICATIONS_QUERY_KEY);
    }
  });

  return {
    markAsVisited: mutate,
    isLoading
  };
};
